import ErrorUtils from "~/utils/error_utils";

export default {
    getPasswordSettings() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/organization/password-settings/form-json`,
                type: 'GET',
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getPasswordRules(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/organization/password-settings/password-rules-json?token=${payload}`,
                type: 'GET',
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getPasswordRulesFromUserEmail(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/organization/password-settings/password-rules-email-json?email=${payload}`,
                type: 'GET',
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    postPasswordSettingsForm(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/organization/password-settings/form',
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    postMfaSettings(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/organization/password-settings/mfa-settings',
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    postSetPassword(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/forgot-password/set-password',
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(xhr);
            });
        });
    },

    updateExpiredPassword(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/login/update-expired-password',
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getOrgSecurityQuestionsForm() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/organization/password-settings/org-security-questions-form',
                type: 'GET'
            })
            .done((json) => {
                resolve(json);
            })
            .fail((xhr) => {
                reject(xhr);
            });
        });
    },

    postOrgSecurityQuestionSettingsForm(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/organization/password-settings/org-security-question-settings',
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    postOrgSecurityQuestionsForm(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/organization/password-settings/org-security-questions-form',
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    postAnswerSecurityQuestionsForm(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/forgot-password/security-question-answers',
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getRecaptchaSiteKey() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/forgot-password/get-recaptcha-site-key`,
                type: 'GET',
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    validateRecaptcha(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/forgot-password/validate-recaptcha',
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },
}
